<mat-card *ngIf="statisticsHeader && statisticsHeader.statistics" class="statistics-card">
  <mat-card-title>
    <div fxLayout="row" fxLayoutAlign="center center">
      <div fxFlex>
        <button mat-icon-button (click)="refreshStatistics()">
          <mat-icon>refresh</mat-icon>
        </button>
        <span>Estadísticas Edictos</span>
      </div>
      <div *ngIf="editionHeader.actual.status === 'P'" fxFlex color="accent">
        ESTA EDICIÓN YA HA SIDO PUBLICADA
      </div>
      <div fxLayout="row" fxLayoutAlign="center center">
        <button mat-icon-button [disabled]="loading || !editionHeader.previous" (click)="prevStatistics()">
          <mat-icon aria-label="Anterior">navigate_before</mat-icon>
        </button>
        <mat-datepicker #picker></mat-datepicker>
        <button mat-button (click)="picker.open()">
          <div *ngIf="editionHeader.actual.publishDates.length > 1" class="mat-subheading-1">
            <span>Edición: </span>
            <span> {{editionHeader.actual.publishDates[0] | date: 'yyyy/MM/dd'}} </span>
            <span> al </span>
            <span> {{editionHeader.actual.publishDates[editionHeader.actual.publishDates.length -1] | date: 'yyyy/MM/dd'}} </span>
          </div>
          <div *ngIf="editionHeader.actual.publishDates.length === 1" class="mat-subheading-1">
            <span>Edición: </span>
            <span> {{editionHeader.actual.publishDates[0] | date: 'yyyy/MM/dd'}} </span>
          </div>
        </button>
        <input hidden class="edition-date" [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="onChangeDate($event)">
        <button mat-icon-button [disabled]="loading || !editionHeader.next" (click)="nextStatistics()">
          <mat-icon aria-label="Siguiente">navigate_next</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-title>
  <mat-card-content>
    <div fxLayout="row wrap" fxLayoutWrap>
      <div fxFlex fxFlex.xs="50" fxFlex.sm="33.3333" fxLayout="column" fxLayoutAlign="center center" *ngFor="let item of statisticsHeader.statistics">
        <span class="mat-display-3">{{item.quantity}}</span>
        <span class="mat-caption">{{item.statusName}}</span>
      </div>
    </div>
  </mat-card-content>
</mat-card>
